import { Badge, BadgeProps } from '@mantine/core';
import { memo } from 'react';

export interface TagBadgeProps extends Omit<BadgeProps, 'color' | 'children'> {
  name: string;
  color?: string;
  size?: BadgeProps['size'];
}

const TagBadge = memo(({ name, color = '#6d28d9', size = 'xs', ...props }: TagBadgeProps) => {
  return (
    <Badge
      size={size}
      style={{
        backgroundColor: color,
        color: '#ffffff',
      }}
      {...props}
    >
      {name}
    </Badge>
  );
});

TagBadge.displayName = 'TagBadge';

export default TagBadge;
